<template>
	<div :class="['table-error-display-alert-wrapper', alertClass]">
		<div class="table-error-display-alert-header">
			{{ $t(errorKey) }}
		</div>
		<div v-if="messages.length" class="table-error-display-alert-values">
			<div class="table-error-display-alert-values-subgrid" v-for="(msg, index) in messages" :key="index">
				<div class="table-error-display-alert-value-key">{{ msg.key }}</div>
				<div class="table-error-display-alert-value-message">
					<div class="table-error-display-alert-value-message-content">{{ msg.message }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';

type TableErrorLevel = 'error' | 'warning';

interface TableErrorMessageItem {
	key: string;
	message: string;
}

export default {
	props: {
		errorKey: {
			type: String,
			required: true,
		},
		errorLevel: {
			type: String as PropType<TableErrorLevel>,
			required: true,
		},
		messages: {
			type: Array as PropType<TableErrorMessageItem[]>,
			required: true,
		},
	},
	setup(props) {
		const alertClass = computed(() => props.errorLevel === 'error' ? 'alert-error' : 'alert-warning');
		return {
			alertClass,
		};
	},
};
</script>

<style scoped>
.table-error-display-alert-wrapper {
	box-sizing: border-box;
	padding-inline: 7px;
	font-size: 12px;
	line-height: 20px;
	white-space: break-spaces;
	border-radius: 5px;
	max-width: 450px;
}

.table-error-display-alert-header {
	font-weight: bold;
	border-block-end: 1px solid;
}

.table-error-display-alert-values {
	display: grid;
	grid-template-columns: min-content auto;
}

.table-error-display-alert-values-subgrid {
	grid-column: span 2;
	display: grid;
	grid-template-columns: subgrid;
}

.table-error-display-alert-value-key,
.table-error-display-alert-value-message {
	margin-block: 3px;
	margin-inline-end: 4px;
	white-space: pre-wrap;
}

.table-error-display-alert-value-key {
	max-width: 200px;
}

.alert-error {
	color: #d66565;
	background: #fdecea;
	border: 1px solid #f5a3a8;
}

.alert-warning {
	color: #b6870f;
	background: #fffbe6;
	border: 1px solid #ffe58f;
}

.table-error-display-alert-value-message-content {
	white-space: pre-wrap;
	word-wrap: break-word;
	border-inline-start: 1px solid currentColor;
	border-inline-start: 1px solid color-mix(in srgb, currentColor 60%, transparent);
	padding-inline-start: 4px;
}
</style>
